import { render } from "./LimitsModal.vue?vue&type=template&id=43ed0f8e&scoped=true"
import script from "./LimitsModal.vue?vue&type=script&lang=js"
export * from "./LimitsModal.vue?vue&type=script&lang=js"

import "./LimitsModal.vue?vue&type=style&index=0&id=43ed0f8e&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ed0f8e"]])

export default __exports__